import React from 'react';
import {useState, useEffect, useRef} from 'react';
import NavLink from 'ui-components/NavLink';
import xClass from 'utils/xClass';

const HourGlass = ({
	on = false,
	onClick,
	id,
	totalTime = 10000,
	framePath = "M29.759,79.974c-8.573,0.001-17.146,0.032-25.72-0.013 c-3.822-0.021-3.833-0.091-3.911-3.82c-0.024-1.13,0.001-2.265,0.064-3.395c0.037-0.654,0.287-1.487,0.977-1.495 c3.509-0.037,2.914-2.567,3.27-4.725c1.019-6.187,4.332-11.463,7.284-16.864c1.244-2.276,2.456-4.604,4.001-6.679 c1.531-2.054,1.219-3.72-0.004-5.741c-3.188-5.277-6.431-10.525-8.922-16.187c-1.32-3-2.36-6.013-2.528-9.287 c-0.048-0.943,0.15-2.366-1.017-2.429c-4.435-0.242-3.029-3.465-3.084-5.732c-0.084-3.409,0.132-3.571,3.61-3.579 c17.476-0.037,34.953-0.039,52.428,0.003c3.47,0.009,3.645,0.189,3.623,3.597c-0.015,2.217,1.059,4.985-2.445,5.943 c-0.658,0.181-0.561,1.12-0.557,1.747c0.03,5.396-2.476,9.991-4.901,14.565c-2.051,3.865-4.342,7.613-6.635,11.347 c-1.222,1.987-1.356,3.63,0.006,5.753c3.419,5.326,6.682,10.76,9.237,16.564c0.982,2.234,1.862,4.495,2.201,6.913 c0.273,1.938-0.522,4.146,2.446,5.077c1.153,0.362,0.998,6.927,0.081,7.804c-0.946,0.904-2.173,0.612-3.291,0.615 C47.236,79.985,38.498,79.972,29.759,79.974z M30.759,9.112c-6.271,0-12.541,0.04-18.81-0.024c-1.911-0.019-2.583,0.7-2.609,2.566 c-0.037,2.706,0.899,5.104,2.111,7.393c2.812,5.304,5.604,10.629,8.716,15.765c2.161,3.565,2.398,6.661,0.099,10.328 c-3.19,5.087-5.901,10.465-8.741,15.758c-1.071,1.997-2.003,4.074-2.146,6.396c-0.204,3.324,0.003,3.632,3.404,3.658 c6.6,0.053,13.199,0.018,19.8,0.017c5.445,0,10.89-0.07,16.333,0.027c2.201,0.04,2.825-0.87,2.816-2.888 c-0.011-2.357-0.729-4.443-1.828-6.462c-3.185-5.844-6.265-11.749-9.617-17.502c-1.647-2.826-1.724-5.192-0.086-8.117 c3.332-5.946,7.117-11.656,9.897-17.9c0.864-1.938,1.708-3.829,1.63-6.021c-0.099-2.754-0.161-2.95-3.151-2.98 C42.638,9.066,36.698,9.108,30.759,9.112z",
	sandPaths = [
		"M45.417,60.575l-29.7,0.113c-0.108,0.332-0.216,0.664-0.312,1.001 c-0.523,1.828,0.128,2.846,2.091,2.874c2.967,0.042,5.934,0.027,8.901,0.025c5.606-0.004,11.212,0.055,16.815-0.056 c2.553-0.05,3.141-1.021,2.411-3.429C45.569,60.924,45.486,60.751,45.417,60.575z",
		"M42.717,55.296l-25.18,1.054c-0.717,1.392-1.33,2.838-1.82,4.338 l29.7-0.113c-0.223-0.576-0.49-1.14-0.766-1.694C44.045,57.662,43.399,56.467,42.717,55.296z",
		"M40.613,51.891l-20.565,0.354c-0.938,1.313-1.778,2.681-2.51,4.104 l25.18-1.054C42.047,54.141,41.344,53.006,40.613,51.891z",
		"M37.574,47.584l-13.885-0.12c-1.224,1.534-2.425,3.085-3.568,4.676 c-0.025,0.035-0.048,0.07-0.073,0.105l20.565-0.354C39.649,50.423,38.647,48.981,37.574,47.584z",
		"M35.241,44.695c-0.638-0.747-1.15-1.472-1.541-2.179l-6.102-0.021 c-0.239,0.399-0.521,0.799-0.85,1.199c-1.027,1.252-2.051,2.506-3.06,3.771l13.885,0.12C36.821,46.605,36.046,45.639,35.241,44.695 z",
		"M33.04,37.673l-4.807-0.02c0.556,1.574,0.348,3.2-0.634,4.841 l6.102,0.021C32.773,40.834,32.571,39.246,33.04,37.673z",
		"M35.541,33.818c0.486-0.487,0.964-0.98,1.434-1.479H23.883 c0.693,0.767,1.411,1.518,2.188,2.231c1.082,0.995,1.789,2.028,2.162,3.083l4.807,0.02C33.42,36.393,34.237,35.122,35.541,33.818z",
		"M41.232,27.2l-21.066,0.289c1.102,1.703,2.338,3.322,3.718,4.85 h13.091C38.508,30.708,39.944,29.006,41.232,27.2z",
		"M43.492,23.638l-25.499,0.124c0.667,1.278,1.393,2.52,2.172,3.728 L41.232,27.2C42.048,26.057,42.81,24.875,43.492,23.638z",
		"M44.885,20.82c0.101-0.236,0.19-0.457,0.277-0.673l-28.832,0.16 c0.517,1.173,1.073,2.324,1.662,3.454l25.499-0.124C43.995,22.726,44.47,21.793,44.885,20.82z",
		"M41.371,15.362c-3.791-0.039-7.583-0.008-11.374-0.008 c0-0.011,0-0.022,0-0.034c-3.957,0-7.913-0.02-11.869,0.007c-2.946,0.02-3.561,0.769-2.437,3.498 c0.206,0.499,0.424,0.99,0.641,1.482l28.832-0.16C46.75,16.199,46.02,15.411,41.371,15.362z"
	]
}) => {
	const [elapsed, setElapsed] = useState(0);
	const intervalRef = useRef();
	const prevIdRef = useRef(id);

	const tick = () => {
		setElapsed((prevElapsed) =>
			prevElapsed === sandPaths.length ? 0 : prevElapsed + 1
		);
	};

	const turnOff = () => {
		if (intervalRef.current) {
			clearInterval(intervalRef.current);
			intervalRef.current = undefined;
		}
		setElapsed(0);
	};

	const turnOn = () => {
		const totalSands = sandPaths.length;
		const tickTime = totalTime / (totalSands + 1);
		intervalRef.current = setInterval(tick, tickTime);
	};

	// Handle on/off state changes
	useEffect(() => {
		if (on) {
			turnOn();
		} else {
			turnOff();
		}

		// Cleanup on unmount
		return () => {
			if (intervalRef.current) {
				clearInterval(intervalRef.current);
			}
		};
	}, [on]);

	// Handle id changes while on
	useEffect(() => {
		if (on && prevIdRef.current !== id) {
			turnOff();
			turnOn();
		}
		prevIdRef.current = id;
	}, [id, on]);

	return (
		<NavLink
			title="auto"
			onClick={onClick}
			id="auto-link"
			className={xClass(
				'auto-link',
				{on},
				{flip: sandPaths.length === elapsed}
			)}
		>
	        <svg id="hourglass" viewBox="0 0 60 80">
	            <path
	            	id="frame"
	            	fillRule="evenodd"
	            	clipRule="evenodd"
	            	d={framePath}/>
	            <g id="sand">{
	            	sandPaths.map((p, idx) =>
	            		<path
	            			key={idx}
	            			fillRule="evenodd"
	            			clipRule="evenodd"
	            			d={p}
	            			fill={
	            				elapsed > idx
	            				? "black"
	            				: "transparent"
	            			}
	            		/>
	            	)
	            }</g>
	        </svg>
        </NavLink>
	);
};

export default HourGlass;